import { FeatureFlags, useFeatureFlag } from '@src/hooks/useFeatureFlag';
import { ReactNode } from 'react';

interface FeatureFlagProps {
  active: () => ReactNode;
  feature: keyof typeof FeatureFlags;
  fallback?: () => ReactNode;
  pending?: () => ReactNode;
}

// In the future, we can handle multiple features at once
const FeatureFlag = (props: FeatureFlagProps) => {
  const { active = () => null, feature, fallback = () => null, pending = () => null } = props;

  const { areFeatureFlagsReady, isFeatureFlagEnabled } = useFeatureFlag();

  if (!areFeatureFlagsReady) {
    return pending();
  }

  const isActiveFeature = isFeatureFlagEnabled(feature);

  return isActiveFeature ? active() : fallback();
};

export default FeatureFlag;
